module.exports = __webpack_public_path__ + "img/sec1.e03fe970.png";